// @flow
import client from '../../client'

// API Endpoint
export const SEND_APP_LINK = '/auth/send-app-link'

/**
 * Sends the app link to given phone number with country code
 * @returns {Promise}
 */
export const sendAppLink = (data: {
  phone_number: string,
  country_code_name: string,
}): Promise<any> => client.post(SEND_APP_LINK, { body: data })

export default sendAppLink
